<div class="modal-header confirm">
    <h2 class="modal-title">{{ title }}</h2>
    <button (click)="dismiss()" aria-label="Close" class="close" type="button">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body text-center">
    <p>{{ message }}</p>
</div>
<div class="modal-footer">
    <button (click)="decline()" class="btn-light" type="button">{{ btnCancelText }} <i class="fa fa-close"></i>
    </button>
    <button (click)="accept()" class="navy-btn" type="button">{{ btnOkText }} <i class="fa fa-check"></i></button>
</div>